module.exports = __webpack_public_path__ + "img/gys_9@2x.af9a5c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_9@2x.png
// module id = PHxe
// module chunks = 0